import React from 'react';
import { History, RefreshCw } from 'lucide-react';

const AuditLogSection = ({ auditLog, auditLoading, onRefresh }) => {
  return (
    <div className="bg-slate-800/50 rounded-2xl border border-slate-700 p-6" data-testid="audit-log-section">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-white font-semibold flex items-center gap-2">
          <History className="w-5 h-5 text-slate-400" />
          Edit Audit Log (Last 30 days)
        </h3>
        <button
          onClick={onRefresh}
          className="p-1.5 text-slate-400 hover:text-white"
          disabled={auditLoading}
        >
          <RefreshCw className={`w-4 h-4 ${auditLoading ? 'animate-spin' : ''}`} />
        </button>
      </div>

      {auditLoading ? (
        <div className="flex items-center justify-center py-6">
          <RefreshCw className="w-5 h-5 text-emerald-400 animate-spin" />
        </div>
      ) : auditLog.length === 0 ? (
        <p className="text-slate-500 text-center py-6">No edits recorded for this driver</p>
      ) : (
        <div className="space-y-3 max-h-96 overflow-y-auto">
          {auditLog.map((entry, idx) => {
            const afterState = (() => {
              try { return typeof entry.after_state === 'string' ? JSON.parse(entry.after_state) : (entry.after_state || {}); }
              catch { return {}; }
            })();
            const editTypeLabels = {
              'ADJUST_CROSSOVER': 'Crossover Adjusted',
              'INSERT_MISSED_ENTRY': 'Missed Entry Inserted',
              'INSERT_MISSED_WORK': 'Missed Work Inserted',
            };
            const editTypeColors = {
              'ADJUST_CROSSOVER': 'text-amber-400 bg-amber-500/10',
              'INSERT_MISSED_ENTRY': 'text-emerald-400 bg-emerald-500/10',
              'INSERT_MISSED_WORK': 'text-blue-400 bg-blue-500/10',
            };
            return (
              <div key={entry.edit_id || idx} className="p-3 bg-slate-700/30 rounded-lg border border-slate-700" data-testid={`audit-entry-${idx}`}>
                <div className="flex items-center justify-between mb-2">
                  <span className={`px-2 py-0.5 rounded text-xs font-medium ${editTypeColors[entry.edit_type] || 'text-slate-400 bg-slate-700'}`}>
                    {editTypeLabels[entry.edit_type] || entry.edit_type}
                  </span>
                  <span className="text-slate-500 text-xs">
                    {new Date(entry.created_at).toLocaleString('en-AU', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                  </span>
                </div>
                <p className="text-slate-300 text-sm mb-1">
                  <span className="text-slate-500">Reason:</span> {entry.reason}
                </p>
                {afterState.start_ts && (
                  <p className="text-slate-400 text-xs">
                    {afterState.segment_type || 'Entry'}: {new Date(afterState.start_ts).toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit' })} – {new Date(afterState.end_ts).toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit' })}
                  </p>
                )}
                {afterState.end_ts && !afterState.start_ts && (
                  <p className="text-slate-400 text-xs">New end: {new Date(afterState.end_ts).toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit' })}</p>
                )}
                {entry.evidence_url && (
                  <a href={entry.evidence_url} target="_blank" rel="noopener noreferrer" className="text-blue-400 text-xs underline mt-1 inline-block">View evidence</a>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AuditLogSection;
